import { render, staticRenderFns } from "./aggregator-settings.vue?vue&type=template&id=4c549fe9&scoped=true"
import script from "./aggregator-settings.vue?vue&type=script&lang=js"
export * from "./aggregator-settings.vue?vue&type=script&lang=js"
import style0 from "./aggregator-settings.vue?vue&type=style&index=0&id=4c549fe9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c549fe9",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/aggregator-settings.vue
// module id = XHlJ
// module chunks = 0